/*
 * @Author: your name
 * @Date: 2021-12-21 12:42:43
 * @LastEditTime: 2022-03-22 13:45:39
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \hello\src\utils\request.js
 */

import axios from "axios";
import i18n from "@/lang/index";
// import vuex from 'vuex';
// import app from '../main';
// import toastRender from '../components/Tips/Tips'
// import Vue from 'vue'
// Notice({ message: "hello world" })
import Notice from "../components/Tips/Tips";

let Service = axios.create({
  timeout: 7000,
  // baseURL: "https://sandbox.ulugame.com",
  baseURL: "https://sdk.ulugame.com/v2",
});

export function getCode(code) {
  switch (code) {
    case 10000:
      Notice({ message: i18n.global.t("RechargePage.Databaseerror") });
      break;
    case 20000:
      Notice({ message: i18n.global.t("RechargePage.operror") });
      break;
    case 30100:
      Notice({ message: i18n.global.t("customer.parameterIncomplete") });
      break;
    case 30300:
      localStorage.clear();
      //window.location.href = "/pcsdk/#/";
      Notice({ message: i18n.global.t("RechargePage.Invaildlogin") });
      break;
    case 40001:
      Notice({ message: i18n.global.t("customer.EmailFormatError") });
      break;
    case 40002:
      Notice({ message: i18n.global.t("RechargePage.Emailwasbinded") });
      break;
    case 40003:
      Notice({ message: i18n.global.t("customer.AccountsNotence") });
      break;
    case 40004:
      Notice({ message: i18n.global.t("RechargePage.Codeerror") });
      break;
    case 40308:
      Notice({ message: i18n.global.t("customer.AccountsDele") });
      break;
    case 40005:
      Notice({ message: i18n.global.t("RechargePage.bindedalready") });
      break;
    case 40006:
      Notice({ message: i18n.global.t("customer.PasswordError") });
      break;
    case 40007:
      Notice({ message: i18n.global.t("RechargePage.ULUaccount") });
      break;
    case 40008:
      Notice({ message: i18n.global.t("RechargePage.Codeinvalid") });
      break;
    case 40009:
      Notice({ message: i18n.global.t("RechargePage.haveRegist") });
      break;
    case 40300:
      Notice({ message: i18n.global.t("RechargePage.Requestfrequently") });
      break;
    case 40011:
      Notice({ message: i18n.global.t("RechargePage.notRegister") });
      break;
    case 40012:
      Notice({ message: i18n.global.t("RechargePage.oneBind") });
      break;
    case 40306:
      Notice({ message: i18n.global.t("RechargePage.idError") });
      break;
    case 40305:
      Notice({ message: i18n.global.t("customer.AccountsSeal") });
      break;
    default:
      Notice({ message: "error" });
  }
}
//请求拦截器
Service.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (config.url) {
      if (token) {
        config.headers["token"] = token;
      }
      // if(config.url == '/api/member/pay/ustore/login/v2' || config.url == '/api/member/pay/autoLogin'){
      //   config.headers["versionId"] = '1.0.0';
      // }
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

//respone拦截器
Service.interceptors.response.use(
  (response) => {
    if (!response.data || response.data.code != 0) {
      if (response.data.code != 0) {
        getCode(response.data.code, response.data.msg);
      }
    }
    return response.data;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export const request = ({
  method = "post",
  data = {},
  url = "",
  params = {},
}) => {
  return Service.request({ data, url, method, params });
};

export const requests = ({
  method = "PUT",
  data = {},
  url = "",
  params = {},
}) => {
  return Service.request({ data, url, method, params });
};

export const AInformation = ({
  method = "post",
  data = {},
  url = "",
  params = {},
}) => {
  return Service.request({ data, url, method, params });
};
